import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react";
import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";

import { persistor, store } from './store';
import App from './App';
import './index.css'
import { ScrollFAB } from './components';
import './utils/dayjsConfig';

Sentry.init({
    enabled: import.meta.env.PROD,
    dsn: "https://d1d0d9dbe5907a2b6815cf5650a9987d@o4509330814271488.ingest.de.sentry.io/4509336970068048",
    sendDefaultPii: true
});

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <div className='relative'>
                    <App />
                    <ScrollFAB />
                </div>
            </PersistGate>
        </Provider>
    </StrictMode>,
)
